import React from 'react';
import FeaturedStoryCards from '../../components/FeaturedStoryCards';
import LatestNewsCards from '../../components/LatestNewsCards';
import PressReleaseLists from '../../components/PressReleaseLists';
import BlogPosts from '../../components/BlogPosts';
import { NavLink } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './style.css';

const NewsRoom = () => {
  return (
    <>
      <Helmet>
        <title>에이아이웍스 – AI 데이터 최신 뉴스</title>
        <meta name='description' content='에이아이웍스의 뉴스 및 발표와 관련된 기사 및 보도자료를 살펴보세요.' />
      </Helmet>
      <section className='news-room'>
        <section className='visual_wrap'>
          <span className='line'></span>
          <div className='inner'>
            <div className='tit_wrap'>
              <h2>News</h2>
              <p id='aw_visual_txt1'>에이아이웍스의 뉴스 및 발표와 관련된 기사 및 보도자료를 살펴보세요.</p>
            </div>
          </div>
        </section>
        <div className='container'>
          <div className='inner'>
            <h2 className='latest-header'>Latest News</h2>
            <LatestNewsCards />
            <div className='header'>
              <h2>Press Release</h2>
              <NavLink to='/pressroom'>
                <button className='tolist-btn'>모두보기</button>
              </NavLink>
            </div>
            <PressReleaseLists />
          </div>
          <div className='inner'>
            <div className='header'>
              <h2>Featured Stories</h2>
            </div>
            <FeaturedStoryCards />
          </div>
          <BlogPosts />
        </div>
      </section>
    </>
  );
};

export default NewsRoom;
